// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React, { Component } from 'react';
export class TextBox extends Component {
    constructor(props) {
        super(props);
        this.onSubmitEvent = this.onSubmitEvent.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.selectAllText = this.selectAllText.bind(this);
        this.props.onSubscribeSelectAllInTextBox(this.selectAllText);
        this.inputRef = React.createRef();
        this.containerRef = React.createRef();
    }
    componentWillUnmount() {
        this.props.onUnsubscribeSelectAllInTextBox(this.selectAllText);
    }
    onSubmitEvent(event) {
        event.preventDefault();
    }
    onChange(event) {
        this.props.onChange(event.target.value);
    }
    onKeyDown(event) {
        this.props.onKeyDown(event);
    }
    onWheel(event) {
        this.props.onWheel(event);
    }
    onClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    onFocus(event) {
        var _a, _b, _c;
        (_a = this.containerRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('focused', '');
        (_c = (_b = this.props).onFocus) === null || _c === void 0 ? void 0 : _c.call(_b, event);
    }
    onBlur(event) {
        var _a, _b, _c;
        (_a = this.containerRef.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('focused');
        (_c = (_b = this.props).onBlur) === null || _c === void 0 ? void 0 : _c.call(_b, event);
    }
    selectAllText() {
        var _a;
        (_a = this.inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
    }
    render() {
        var _a;
        const { elementStyle, additionalClass, haveError, placeholder, autofocus, isReadOnly, maxLength, text, tooltip, inputType, enabled, svgIcon, isMaterialDesign } = this.props;
        const containerClass = `${elementStyle} ${additionalClass} ${haveError ? 'js-input-container-error' : ''}${!enabled ? ' disabled' : ''}`;
        return (React.createElement("div", { className: containerClass, ref: this.containerRef },
            React.createElement("form", { autoComplete: "off", onSubmit: this.onSubmitEvent },
                React.createElement("input", { ref: this.inputRef, type: inputType, maxLength: maxLength, placeholder: placeholder, spellCheck: "false", value: text, "data-tooltip": tooltip, autoFocus: autofocus, readOnly: isReadOnly, autoComplete: "off", onChange: this.onChange, onKeyDown: this.onKeyDown, onWheel: this.onWheel, onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur, className: isMaterialDesign ? 'material-input' : '' }),
                React.createElement("label", { htmlFor: (_a = this.inputRef.current) === null || _a === void 0 ? void 0 : _a.id },
                    isValidString(svgIcon) && (React.createElement("svg", null,
                        React.createElement("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${svgIcon}` }))),
                    placeholder))));
    }
}
TextBox.defaultProps = {
    enabled: true,
    maxLength: 200,
    isReadOnly: false,
    placeholder: '',
    text: '',
    svgIcon: '',
    inputPatern: null,
    haveError: false,
    autofocus: false,
    inputType: 'text',
    elementStyle: 'js-input-container',
    additionalClass: '',
    isMaterialDesign: false,
    tooltip: null,
    onKeyDown: () => { },
    onWheel: () => { },
    onSubscribeSelectAllInTextBox: () => { },
    onUnsubscribeSelectAllInTextBox: () => { }
};
